import {ChainId} from 'lz-chains';
import {Token} from 'x-bridge-layerzero';

const tokens = [
  // V2
  //new Token(ChainId.FUJI, '0x0B22E6a0f1CBFe2ac4e9cb217A4A9BA29151734d', 6, 'XHNY'),
  //new Token(ChainId.MUMBAI, '0xb4062068aFC2fE3C7668BAcf193753e13Fccf7B8', 6, 'XHNY'),

 // V1 updated
 new Token(ChainId.FUJI, '0x3bA2FDD488ec9Fe3c199916322959997E84fF0a1', 6, 'XHNY'),
 new Token(ChainId.MUMBAI, '0xF8AfB225343c85Ce2f4181CD273D01bd79147fd4', 6, 'XHNY'),
 new Token(ChainId.ASTAR_TESTNET, '0x571cadbeDfe46035bB69C227AcC5892563F7FA09', 6, 'XHNY'),
 new Token(ChainId.MOONBEAM_TESTNET, '0x3f8B3233AA1BD4AcAD3f17c30DFFDF3C855FCcc0', 6, 'XHNY'),
 new Token(ChainId.ZKATANA_TESTNET, '0x9E900F8CAF941F91fCd19873Af5BD58cF0B860b0', 6, 'XHNY'),
 //new Token(ChainId.BASE_TESTNET, '', 6, 'XHNY'),
 // V1 old
 //new Token(ChainId.FUJI, '0x4f6aF3a9e93b302e00B2F8091B554AE2e2d2C75f', 8, 'HONEY'),
 //new Token(ChainId.MUMBAI, '0x0d2ec60dC185B9823326973e0221FEBAD7E1CD13', 8, 'HONEY'),
 //new Token(ChainId.ARBITRUM_GOERLI,'0x9E900F8CAF941F91fCd19873Af5BD58cF0B860b0', 8, 'HONEY'),
 //new Token(ChainId.BSC_TESTNET,    '0x9E900F8CAF941F91fCd19873Af5BD58cF0B860b0', 8, 'HONEY'),
 //new Token(ChainId.MOONBEAM_TESTNET, '0x271894a437E1f45C046A1b7C2894C7027092c28E', 8, 'HONEY'),
 //new Token(ChainId.BASE_TESTNET, '0x9E900F8CAF941F91fCd19873Af5BD58cF0B860b0', 8, 'HONEY'),
 //new Token(ChainId.ZKPOLYGON_TESTNET, '0x9E900F8CAF941F91fCd19873Af5BD58cF0B860b0', 8, 'HONEY'),
//new Token(ChainId.APTOS_TESTNET, '0x271894a437E1f45C046A1b7C2894C7027092c28E', 8, 'HONEY'),
//new Token(ChainId.METIS, '0x271894a437E1f45C046A1b7C2894C7027092c28E', 8, 'HONEY'),
//new Token(ChainId.ZKSYNC_TESTNET, '0x271894a437E1f45C046A1b7C2894C7027092c28E', 8, 'HONEY'),
// new Token(ChainId.ASTAR_TESTNET, '0x9E900F8CAF941F91fCd19873Af5BD58cF0B860b0', 8, 'HONEY'),
//new Token(ChainId.APTOS_TESTNET, '', 8, 'HONEY'),
];

const proxy = [
  {
    chainId: ChainId.RINKEBY,
    address: '0x271894a437E1f45C046A1b7C2894C7027092c28E',
  },
];

export const testnet = {tokens, proxy};
